<template>
  <Timestamp :date="claim.creationDate" />
  <Info :claim />

  <div class="space-y-24">
    <Message
      v-for="message in claim.messages"
      :key="message.messageId"
      :message
    />
  </div>
</template>

<script setup lang="ts">
import type { Claim } from '~/api/customer-request/types'

import Info from './components/Info/Info.vue'
import Message from './components/Message/Message.vue'
import Timestamp from './components/Timestamp.vue'

defineProps<{
  claim: Claim
}>()
</script>
